import { useEffect, useState } from 'react';
import { usePrivileges } from '../contexts/PrivilegeContext';
import { isViewingAsClient, onAdminViewChange } from '../lib/adminView';

/**
 * Whether the current user should see curation tools on post cards.
 *
 * True for anyone who can manage curated content — the same privilege that
 * gates the Edits admin — unless they have deliberately switched to the
 * client view.
 */
export function useCurator(): { isCurator: boolean; viewingAsClient: boolean } {
  const { hasAny } = usePrivileges();
  const [viewingAsClient, setViewingAsClient] = useState(isViewingAsClient);

  useEffect(
    () => onAdminViewChange(() => setViewingAsClient(isViewingAsClient())),
    [],
  );

  const canCurate = hasAny(['curation.featured.manage']);

  return { isCurator: canCurate && !viewingAsClient, viewingAsClient: canCurate && viewingAsClient };
}
